module.exports = __webpack_public_path__ + "static/media/logo-veneto-edificios.ded1d01f.svg";